import { render, staticRenderFns } from "./LabelEditor.vue?vue&type=template&id=6cf198b1&scoped=true&"
import script from "./LabelEditor.vue?vue&type=script&lang=ts&"
export * from "./LabelEditor.vue?vue&type=script&lang=ts&"
import style0 from "./LabelEditor.vue?vue&type=style&index=0&id=6cf198b1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf198b1",
  null
  
)

export default component.exports